import { WalletType } from '../../types/wallet';

export const BybitWalletTypes = [
  WalletType.CLOUD,
  WalletType.MNEMONIC_PHRASE,
  WalletType.PRIVATE_KEY,
  WalletType.MPC,
];
